import React, { useEffect, useState } from "react";
import axios from "axios";
import { Modal, Table } from "react-bootstrap";
import config from '../../../config';

const TemplateDetailModal = ({ show, onHide, template }) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (!template) return;

    axios
      .get(
        `${config.apiBaseUrl}/fees/fee_templates.php?action=details&class_id=${template.class_id}&session=${template.session}`
      )
      .then((res) => setItems(res.data));
  }, [template]);

  const total = items.reduce(
    (sum, i) => sum + Number(i.amount),
    0
  );

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          Template Details
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Table bordered size="sm">
          <thead className="table-light">
            <tr>
              <th>Fee Name</th>
              <th className="text-end">Amount</th>
            </tr>
          </thead>
          <tbody>
            {items.map((i, idx) => (
              <tr key={idx}>
                <td>{i.fee_name}</td>
                <td className="text-end">
                  ₹{i.amount}
                </td>
              </tr>
            ))}
            <tr>
              <th>Total</th>
              <th className="text-end">
                ₹{total}
              </th>
            </tr>
          </tbody>
        </Table>
      </Modal.Body>
    </Modal>
  );
};

export default TemplateDetailModal;
